import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import './App.css';
import './service/css/Acp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LoginPage from './service/LoginPage';
import RecuperarSenha from './service/RecuperarSenha';
import RedefinirSenha from './service/RedefinirSenha';
import Home from './service/Home';
import Usuarios from './service/Usuarios';
import SelecionaEscola from './service/SelecionaEscola';
import Vinculos from './service/Vinculos';
import Escolas from './service/Escolas';
import Pessoa from './service/Pessoa';
import Pessoas from './service/Pessoas';
import Ata from './service/Ata';
import AtasFinal from './service/AtasFinal';
import ListaCompras from './service/ListaCompras';
import Diretor from './service/Diretor';
import Bancos from './service/Bancos';
import Agencias from './service/Agencias';
import Programas from './service/Programas';
import Acoes from './service/Acoes';
import Naturezas from './service/Naturezas';
import TiposBens from './service/TiposBens';
import Itens from './service/Itens';
import Favorecidos from './service/Favorecidos';
import Contas from './service/Contas';
import Receitas from './service/Receitas';
import Despesas from './service/Despesas';
import Bens from './service/Bens';
import Rendimentos from './service/Rendimentos';
import RecursosProprios from './service/RecursosProprios';
import Devolucoes from './service/Devolucoes';
import Compensacoes from './service/Compensacoes';
import Redistribuicoes from './service/Redistribuicoes';
import DadosFnde from './service/DadosFnde';
import SaldoFnde from './service/SaldoFnde';
import SaldoFndeGestao from './service/SaldoFndeGestao';
import ComparativoSresSaldoFnde from './service/ComparativoSresSaldoFnde';
import Srea from './service/Srea';
import Sres from './service/Sres';
import SreaAjustes from './service/SreaAjustes';
import Dashboard from './service/Dashboard';
import Extratos from './service/Extratos';
import SaldoInvestimento from './service/SaldosInvestimento';
import SaldosConta from './service/SaldosConta';
import TiposPagamento from './service/TiposPagamento';
import Saldos from './service/Saldos';
import SaldoAnterior from './service/SaldoAnterior';
import Imagens from './service/Imagens';
import SessionsAtivas from './service/SessionsAtivas';
import RelatorioReceitaPorCidade from './service/RelatorioReceitaPorCidade';
import { isTokenValid } from './service/utils/auth';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!isTokenValid(token)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  useEffect(() => {
    // Limpar dados obsoletos do mecanismo antigo de controle de abas
    localStorage.removeItem('openTabs');
    localStorage.removeItem('windowCount');
    localStorage.removeItem('pendingAnoBase');
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/redefinir-senha" element={<RedefinirSenha />} />
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/usuarios" element={<PrivateRoute><Usuarios /></PrivateRoute>} />
        {/* /usuario converted to modal inside Usuarios */}
        <Route path="/seleciona_escola" element={<PrivateRoute><SelecionaEscola /></PrivateRoute>} />
        <Route path="/usuario_vinculos" element={<PrivateRoute><Vinculos /></PrivateRoute>} />
        <Route path="/escolas" element={<PrivateRoute><Escolas /></PrivateRoute>} />
        <Route path="/pessoa" element={<PrivateRoute><Pessoa /></PrivateRoute>} />
        <Route path="/pessoas" element={<PrivateRoute><Pessoas /></PrivateRoute>} />
        <Route path="/ata" element={<PrivateRoute><Ata /></PrivateRoute>} />
        <Route path="/atas-final" element={<PrivateRoute><AtasFinal /></PrivateRoute>} />
        <Route path="/lista-compras" element={<PrivateRoute><ListaCompras /></PrivateRoute>} />
        <Route path="/diretor" element={<PrivateRoute><Diretor /></PrivateRoute>} />
        {/* /templates removed */}
        <Route path="/bancos" element={<PrivateRoute><Bancos /></PrivateRoute>} />
        <Route path="/agencias" element={<PrivateRoute><Agencias /></PrivateRoute>} />
        <Route path="/programas" element={<PrivateRoute><Programas /></PrivateRoute>} />
        <Route path="/acoes" element={<PrivateRoute><Acoes /></PrivateRoute>} />
        <Route path="/naturezas" element={<PrivateRoute><Naturezas /></PrivateRoute>} />
        <Route path="/tipos-bens" element={<PrivateRoute><TiposBens /></PrivateRoute>} />
        <Route path="/itens" element={<PrivateRoute><Itens /></PrivateRoute>} />
        <Route path="/favorecidos" element={<PrivateRoute><Favorecidos /></PrivateRoute>} />
        <Route path="/contas" element={<PrivateRoute><Contas /></PrivateRoute>} />
        <Route path="/receitas" element={<PrivateRoute><Receitas /></PrivateRoute>} />
        <Route path="/despesas" element={<PrivateRoute><Despesas /></PrivateRoute>} />
        <Route path="/bens" element={<PrivateRoute><Bens /></PrivateRoute>} />
        <Route path="/rendimentos" element={<PrivateRoute><Rendimentos /></PrivateRoute>} />
        <Route path="/recursos-proprios" element={<PrivateRoute><RecursosProprios /></PrivateRoute>} />
        <Route path="/devolucoes" element={<PrivateRoute><Devolucoes /></PrivateRoute>} />
        <Route path="/compensacoes" element={<PrivateRoute><Compensacoes /></PrivateRoute>} />
        <Route path="/redistribuicoes" element={<PrivateRoute><Redistribuicoes /></PrivateRoute>} />
        <Route path="/dados-fnde" element={<PrivateRoute><DadosFnde /></PrivateRoute>} />
        <Route path="/saldo-fnde" element={<PrivateRoute><SaldoFnde /></PrivateRoute>} />
        <Route path="/saldo-fnde-gestao" element={<PrivateRoute><SaldoFndeGestao /></PrivateRoute>} />
        <Route path="/comparativo-sres-saldo-fnde" element={<PrivateRoute><ComparativoSresSaldoFnde /></PrivateRoute>} />
        {/* /escola-fnde removed */}
        <Route path="/srea" element={<PrivateRoute><Srea /></PrivateRoute>} />
        <Route path="/srea-ajustes" element={<PrivateRoute><SreaAjustes /></PrivateRoute>} />
        <Route path="/sres" element={<PrivateRoute><Sres /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/extratos" element={<PrivateRoute><Extratos /></PrivateRoute>} />
        <Route path="/saldos" element={<PrivateRoute><Saldos /></PrivateRoute>} />
        <Route path="/saldo-anterior" element={<PrivateRoute><SaldoAnterior /></PrivateRoute>} />
        <Route path="/saldos-investimento" element={<PrivateRoute><SaldoInvestimento /></PrivateRoute>} />
        <Route path="/saldos-conta" element={<PrivateRoute><SaldosConta /></PrivateRoute>} />
        <Route path="/tipo-pagamento" element={<PrivateRoute><TiposPagamento /></PrivateRoute>} />
        <Route path="/imagens" element={<PrivateRoute><Imagens /></PrivateRoute>} />
        <Route path="/imagem" element={<PrivateRoute><Navigate to="/imagens" replace /></PrivateRoute>} />
        <Route path="/sessions-ativas" element={<PrivateRoute><SessionsAtivas /></PrivateRoute>} />
        <Route path="/relatorio-receita-por-cidade" element={<PrivateRoute><RelatorioReceitaPorCidade /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
